module.exports = __webpack_public_path__ + "img/favicon.16e97966.svg";